import { useSelector } from "react-redux";

import { ComponentPersonalFitness } from "@components";
import { selectAuth } from "@redux";


export const PagePersonalFitness = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentPersonalFitness
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
